import store from 'dashboard/store';

import Alerts from '../../../templates/views/Alerts';

export default {
  path: 'alerts',
  component: Alerts,
  name: 'Alerts',
  meta: {
    title: t => t('patient.alerts'),
    loggedInOnly: true
  },
  async beforeEnter(to, from, next) {
    const currentPatientId = from.params?.patientId;
    const newPatientId = to.params?.patientId;

    // Update user if back is used as everything stays cached in computed
    if ((currentPatientId === undefined && newPatientId) ||
        currentPatientId !== undefined && newPatientId !== undefined && currentPatientId !== newPatientId
    ) {
      await Promise.all([
        store.dispatch('patientSummary/get', newPatientId, {root: true}),
      ]);
    }

    // await store.dispatch('alerts/getAll');
    next();
  },
};

